import { ComingSoonSection } from "@/components/ComingSoonSection";

const Landing = () => {
  return <ComingSoonSection />;
};

export default Landing;
